export default __webpack_public_path__ + "static/media/orange_panel.67243da0.svg";